import type { Slice } from "@reduxjs/toolkit";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import {
	type OrganizationRadioChannel,
	type RadioChannel,
	WorkspaceRadioChannelUpdatedDto,
} from "@somewear/api";

import type { OrganizationState } from "../organization.state";
import {
	emitOrganizationRadioChannelReceived,
	emitOrganizationRadioChannelUpdated,
	organizationRadioChannelActions,
} from "./organization.radio.actions";

const adapter = createEntityAdapter<OrganizationRadioChannel.AsObject, string>({
	selectId: (orgRadioChannel) => orgRadioChannel.id,
});

export const { selectAll: selectAllOrganizationRadioChannels } = adapter.getSelectors(
	(state: OrganizationState) => state.organizationRadioChannels,
);

export const organizationRadioChannelSlice: Slice = createSlice({
	name: "organizationRadioChannelSlice",
	initialState: adapter.getInitialState(),
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(
			organizationRadioChannelActions.getRadioChannels.fulfilled,
			(state, action) => {
				adapter.setAll(state, action.payload.data.organizationRadioChannelsList);
			},
		);
		builder.addCase(emitOrganizationRadioChannelReceived, (state, action) => {
			adapter.upsertOne(state, action.payload);
		});
		builder.addCase(emitOrganizationRadioChannelUpdated, (state, action) => {
			const existingChannel = adapter.getSelectors().selectById(state, action.payload.id);
			if (existingChannel === undefined) return;

			adapter.upsertOne(state, {
				...(existingChannel as OrganizationRadioChannel.AsObject),
				radioChannel: {
					...(existingChannel.radioChannel as RadioChannel.AsObject),
					isArchived:
						action.payload.status === WorkspaceRadioChannelUpdatedDto.Status.ARCHIVED,
				},
			});
		});
	},
});
